import { jsx as e, jsxs as u } from "react/jsx-runtime";
import { useSpring as g, useTransition as y, a as r } from "@react-spring/web";
import { useState as v, Children as b } from "react";
import x from "../_virtual/info.js";
import { ButtonArea as w } from "../ButtonArea/ButtonArea.js";
import { css as t } from "../apps/ui/styled-system/css/css.js";
function I({
  children: a,
  loading: o,
  opened: n
}) {
  const [c, l] = v(n || !1), s = n ? !0 : c;
  o && (a = /* @__PURE__ */ e(
    "div",
    {
      className: t({
        alignItems: "center",
        color: "var(--text-color-th_base-secondary)",
        display: "flex",
        fontSize: 14,
        height: 18,
        justifyContent: "center"
      }),
      children: o === !0 ? "Loading details…" : o
    }
  ));
  const d = b.toArray(a), m = d.length * 18 + // row height
  (d.length - 1) * 6 + // row gap
  16, { height: h } = g({
    config: {
      friction: 60,
      tension: 1200
    },
    height: s ? m : 34
  }), p = y(
    { loading: o, opened: s },
    {
      config: {
        friction: 40,
        tension: 500
      },
      enter: { opacity: 1, transform: "scale(1)" },
      from: { opacity: 0, transform: "scale(0.95)" },
      initial: { opacity: 1, transform: "scale(1)" },
      keys: (i) => i.opened ? `o-${i.loading}` : "c",
      leave: { display: "none", immediate: !0 }
    }
  );
  return /* @__PURE__ */ e(
    r.div,
    {
      className: t({
        backgroundColor: "var(--background-color-th_base-alt)",
        borderRadius: "var(--radius-th_medium)",
        fontSize: 13,
        position: "relative"
      }),
      style: { height: h },
      children: /* @__PURE__ */ e(
        "div",
        {
          className: t({
            borderRadius: "var(--radius-th_medium)",
            height: "100%"
          }),
          children: p(
            (i, { opened: f }) => f ? /* @__PURE__ */ e(
              r.div,
              {
                className: t({
                  alignItems: "center",
                  display: "flex",
                  gap: 6,
                  justifyContent: "space-between",
                  paddingInline: 12,
                  width: "100%"
                }),
                style: i,
                children: /* @__PURE__ */ e(
                  "div",
                  {
                    className: t({
                      display: "flex",
                      flexDirection: "column",
                      gap: 6,
                      paddingBlock: 8,
                      width: "100%"
                    }),
                    children: a
                  }
                )
              }
            ) : /* @__PURE__ */ e(
              r.div,
              {
                className: t({
                  display: "flex",
                  height: "100%"
                }),
                style: i,
                children: /* @__PURE__ */ u(
                  w,
                  {
                    className: t({
                      alignItems: "center",
                      backgroundColor: "var(--background-color-th_base-alt)",
                      borderRadius: "var(--radius-th_medium)",
                      color: "var(--text-color-th_base-secondary)",
                      display: "flex",
                      gap: 6,
                      height: "100%",
                      justifyContent: "center",
                      width: "100%"
                    }),
                    onClick: () => l(!0),
                    children: [
                      /* @__PURE__ */ e(
                        x,
                        {
                          className: t({
                            height: 16,
                            width: 16
                          })
                        }
                      ),
                      /* @__PURE__ */ e("span", { children: "Show more details" })
                    ]
                  }
                )
              }
            )
          )
        }
      )
    }
  );
}
export {
  I as Details
};
//# sourceMappingURL=Details.js.map
